export default {
    data(){
      return {
        breadcrumb: [{ label: "Trung tâm trợ giúp", path: "/docs"}, { label: "References", path: "/docs/ref"}]
      };
    },

    methods: {},
  };